export enum SettingsTable {
	LOCATIONS = "SHOPS",
}
